import type { Styles } from 'react-joyride';

export const tourStyles: Partial<Styles> = {
  options: {
    arrowColor: '#fff',
    backgroundColor: '#fff',
    overlayColor: 'rgba(55, 45, 72, 0.5)', // primary-950 with opacity
    primaryColor: '#7f6aa0', // primary-700
    textColor: '#444444', // blackLight
    zIndex: 10000,
  },
  spotlight: {
    borderRadius: 12, // rounded-xl
  },
  tooltip: {
    borderRadius: 24, // rounded-3xl (matches modal.content.inner)
    padding: 0, // We handle padding in custom tooltip
  },
  tooltipContainer: {
    textAlign: 'left' as const,
  },
  buttonNext: {
    backgroundColor: '#7f6aa0',
    borderRadius: 8,
    color: '#fff',
    fontFamily: '"Urbanist", sans-serif',
    fontSize: 14,
    fontWeight: 500,
    padding: '8px 16px',
    outline: 'none',
  },
  buttonBack: {
    backgroundColor: 'transparent',
    border: '1.5px solid #DDDDDD', // greyLight
    borderRadius: 8,
    color: '#444444', // blackLight
    fontFamily: '"Urbanist", sans-serif',
    fontSize: 14,
    fontWeight: 500,
    marginRight: 8,
    padding: '8px 16px',
  },
  buttonSkip: {
    color: '#AAAAAA', // greyModerate
    fontFamily: '"Urbanist", sans-serif',
    fontSize: 14,
  },
  buttonClose: {
    color: '#444444', // blackLight
    padding: 8,
  },
  beacon: {
    // Beacon animation color
  },
  beaconInner: {
    backgroundColor: '#7f6aa0', // primary-700
  },
  beaconOuter: {
    backgroundColor: 'rgba(127, 106, 160, 0.2)', // primary-700 with opacity
    borderColor: '#7f6aa0',
  },
};
